import { useFetch } from "./useFetch";
import { getDashboardStats } from "../../../../api/marketplace";

export function useDashboardStats() {
  return useFetch(getDashboardStats);
}
